function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-reply",
  "data-name": "Icon awesome-reply",
  d: "M.487,11.5,10.8,2.593a1.407,1.407,0,0,1,2.325,1.064V8.348c6,.069,11.216.861,14.422,3.962C29.022,13.725,30,16.032,30,19.261a11.978,11.978,0,0,1-4.883,9.031A1.044,1.044,0,0,1,23.472,27.2c2.657-8.5-1.26-10.753-10.347-10.883v5.151A1.407,1.407,0,0,1,10.8,22.533L.487,13.627a1.407,1.407,0,0,1,0-2.129Z",
  transform: "translate(1 -1.221)",
  fill: "#e5007d",
  stroke: "#e5137d",
  strokeWidth: 2
});

var SvgMessenger = function SvgMessenger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28.316,
    viewBox: "0 0 32 28.316",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messenger.bd1acb41.svg";
export { ForwardRef as ReactComponent };